module.exports = __webpack_public_path__ + "images/jsw-crossflow/jira-software.ca2e9a7d7a92c7beea94.svg";